document.addEventListener('DOMContentLoaded', function () {
  // ビデオ終了時・エラー時のポスター表示
  const video = document.getElementById('valx-video');
  const poster = document.getElementById('valx-poster');

  if (video && poster) {
    const showPoster = () => (poster.style.opacity = '1');
    video.addEventListener('ended', showPoster);
    video.addEventListener('error', showPoster);
  }

  const observerOptions = {
    threshold: 0.5,
    rootMargin: '0px 0px -50px 0px',
  };

  function createFadeObserver(selector, delay = 200) {
    return new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const target = entry.target.querySelector(selector);
          if (target) {
            setTimeout(() => target.classList.add('fade-in'), delay);
          }
        }
      });
    }, observerOptions);
  }

  const whyListItems = document.querySelectorAll('.why__list li');
  if (whyListItems.length > 0) {
    const whyObserver = createFadeObserver('.why__list--text', 200);
    whyListItems.forEach((item) => whyObserver.observe(item));
  }

  const storySection = document.querySelector('.story');
  if (storySection) {
    const storyObserver = createFadeObserver('.story__bg', 300);
    storyObserver.observe(storySection);
  }
});
